//@flow
import thunk from 'redux-thunk';
import { init } from '@rematch/core';
import { alert } from '../_reducers/alert.reducer';
import { fieldMessage } from '../_reducers/fieldMessage.reducer';
import { reducer as toastrReducer } from 'react-redux-toastr';
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css';
import * as models from '../models';

export const store = init({
  models,
  redux: {
    reducers: {
      alert,
      toastr: toastrReducer,
      fieldMessage
    },
    middlewares: [thunk]
  }
});
